import React from "react";

// Indent per nesting level of the SR content tree.
const INDENT_PX = 28;

/**
 * Renders the model built by SRModalityService.parseSRDataSet in the same
 * layout as the Advance Viewer: title, patient/study header, then the content
 * tree numbered per level ("1.", "2.", ...) with each item indented under its
 * parent.
 */
const SRReportView = ({ report }) => {
  if (!report) return null;
  const { title, subtitle, sections, items } = report;

  return (
    <div className="sr-report">
      <div className="sr-report-section">
        <div className="sr-report-title">{title}</div>
        {subtitle && <div>{subtitle}</div>}
      </div>

      {sections.map((section) => (
        <div className="sr-report-section" key={section.title}>
          <div className="sr-report-heading">{section.title}</div>
          {section.rows.map((row) => (
            <div key={row.label}>
              {row.label}: {row.value}
            </div>
          ))}
        </div>
      ))}

      {items.map((item, i) => (
        <div
          key={i}
          className={
            "sr-report-item" + (item.depth === 0 ? " sr-report-item-top" : "")
          }
          style={{ paddingLeft: item.depth * INDENT_PX }}
        >
          <span className="sr-report-number">{item.number}.</span>
          <span className={item.isContainer ? "sr-report-container" : undefined}>
            {item.label}
          </span>
          {!item.isContainer && item.value ? `: ${item.value}` : ""}
        </div>
      ))}
    </div>
  );
};

export default SRReportView;
